import React from 'react'

const Forgot = () => {
  return (
    <div>
      
    </div>
  )
}

export default Forgot
